import React from 'react';
import { Box, alpha, useTheme, Typography } from '@mui/material';

const NonWorkingDayOverlay = ({ position, dayWidth, name, kind }) => {
  const theme = useTheme();
  // Public holidays and closing days get a distinct tint (secondary vs.
  // primary, matching the settings grid's own PUBLIC_HOLIDAY/CLOSING_DAY
  // color choice) so a greyed-out Gantt day is distinguishable at a glance
  // instead of always rendering as plain grey regardless of kind.
  const tintColor = kind === 'PUBLIC_HOLIDAY'
    ? theme.palette.secondary.main
    : kind === 'CLOSING_DAY'
      ? theme.palette.primary.main
      : theme.palette.grey[500];

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: position * dayWidth,
        width: dayWidth,
        height: '100%',
        bgcolor: alpha(tintColor, .18),
        borderLeft: kind ? `2px solid ${alpha(tintColor, .5)}` : 'none',
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        pointerEvents: 'none',
        paddingBottom: 2,
        zIndex: 5,
      }}
    >
      <Typography
        sx={{
          writingMode: 'vertical-rl',
          textOrientation: 'mixed',
          transform: 'rotate(180deg)',
          color: theme.palette.grey[700],
          fontSize: '23px',
          fontWeight: 500,
          letterSpacing: 1.7,
          textAlign: 'center',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          maxHeight: '100%',
          px: 0.5,
        }}
      >
        {name}
      </Typography>
    </Box>
  );
};

export default NonWorkingDayOverlay;
